import { useLocation, useNavigate, useRouteLoaderData } from "react-router";
import { useEffect } from "react";
import { PUBLIC_ROUTES } from "../utils/constants";
import { loader } from "~/root";

const TENANT_LOCAL_KEY = "tenant";

// Include the tenant parameter on dev
export const useDetectTenantDev = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = useRouteLoaderData<typeof loader>("root");

  // Only run in development environments
  useEffect(() => {
    // Only run in development (localhost + vercel previews)
    if (typeof window === "undefined" || !data?.isDev) return;

    const url = new URL(window.location.href);
    const tenant = url.searchParams.get("tenant");
    const isDataRequest = url.search.includes("_data=");

    // Don't do anything for data requests or public routes
    if (isDataRequest || PUBLIC_ROUTES.includes(location.pathname)) {
      return;
    }

    if (!tenant) {
      // Get tenant from localStorage if available
      const savedTenant = localStorage.getItem(TENANT_LOCAL_KEY);

      if (savedTenant) {
        // Add tenant param without a server request
        url.searchParams.set("tenant", savedTenant);
        navigate(url.pathname + url.search, {
          replace: true,
          viewTransition: true,
        });
      }
    } else {
      // Save tenant for future navigations
      localStorage.setItem(TENANT_LOCAL_KEY, tenant);
    }
  }, [location.pathname, location.search, navigate, data?.isDev]);
};
